import React, { useState } from 'react';
import { limitations } from './fireDetails';

const SLIDES_TO_SHOW = 2;

interface LimitationsSliderProps {
  itemClassName?: string;
}

const LimitationsSlider: React.FC<LimitationsSliderProps> = ({ itemClassName = '' }) => {
  const [current, setCurrent] = useState(0);
  const maxIndex = Math.max(0, limitations.length - SLIDES_TO_SHOW);

  const handlePrev = () => setCurrent((prev) => Math.max(0, prev - 1));
  const handleNext = () => setCurrent((prev) => Math.min(maxIndex, prev + 1));

  return (
    <div className="relative w-full">
      <div className="flex justify-between mb-4">
        <button
          className="p-2 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-white hover:bg-slate-300 dark:hover:bg-slate-600 disabled:opacity-40"
          onClick={handlePrev}
          disabled={current === 0}
          aria-label="Previous"
        >
          <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M15 19l-7-7 7-7"/></svg>
        </button>
        <button
          className="p-2 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-white hover:bg-slate-300 dark:hover:bg-slate-600 disabled:opacity-40"
          onClick={handleNext}
          disabled={current === maxIndex}
          aria-label="Next"
        >
          <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>
        </button>
      </div>
      <div className="overflow-hidden">
        {limitations.slice(current, current + SLIDES_TO_SHOW).map((limitation, i) => (
          <div
            key={i + current}
            className={`flex items-center gap-4 py-4 px-6 border-b border-slate-200 dark:border-slate-700 last:border-0 hover:bg-slate-100 dark:hover:bg-slate-800/50 transition-all duration-300 ${itemClassName}`}
          >
            <span className="w-12 h-12 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-white flex items-center justify-center text-xl shrink-0">
              <img className="w-8 h-8 dark:invert dark:brightness-0" src={limitation.icon} alt={limitation.title} />
            </span>
            <div className="flex-1">
              <div className="font-semibold text-lg text-slate-900 dark:text-white">{limitation.title}</div>
              <div className="text-base text-slate-600 dark:text-slate-300">{limitation.desc}</div>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-center gap-2 mt-4">
        {Array.from({ length: maxIndex + 1 }).map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`w-3 h-3 rounded-full ${idx === current ? 'bg-slate-900 dark:bg-white' : 'bg-slate-300 dark:bg-slate-600'}`}
            aria-label={`Go to slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default LimitationsSlider;